import {toast} from 'sonner'

export const dismiss = toast.dismiss
